export enum EnumActionNotification {
  DepositSuccess = 'deposit-finished',
  DepositCancelled = 'deposit-cancelled',
  WithdrawalSuccess = 'withdrawal-finished',
  WithdrawalCancelled = 'withdrawal-cancelled',
}
